module.exports = {
  label: {
    headerTitle: 'Site Management',
    AddheaderTitle: 'Add Site Management',
    editPageTitle: 'Edit Site Management',
    siteName: 'Site Name',
    companyName: 'Company',
    selectCompany: 'Select Company',
    modeOfCommunication: 'Please select mode of communication',
    covidSafety: 'Please select covid safety option',
    frequencyWeek: 'Frequency Week',
    workTypes: 'Work Types',
    workPermit: 'Work Permit Template',
    requiredDocuments: 'Required Documents',
    departmentTypes: 'Department Types',
    search: 'Search...',
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      delete: 'Delete',
      edit: 'Edit'
    },
    buttons: {
      add: 'Add',
      save: 'Save',
      cancel: 'Cancel'
    }
  }
}
